import React, { useState } from 'react';
import Header from '../../components/Header';
import PrimaryNav from '../../components/PrimaryNav';
import MobileMenu from '../../components/MobileMenu';
import PlatformCard from './components/PlatformCard';
import ComparisonSummary from './components/ComparisonSummary';
import ConfigurationToolbar from './components/ConfigurationToolbar';

import { Helmet } from 'react-helmet';

const PlatformConfigurationCostManagement = () => {
  const [currency, setCurrency] = useState('ZAR');
  const [vatEnabled, setVatEnabled] = useState(true);
  const [selectedPlatform, setSelectedPlatform] = useState('woocommerce');

  const [wooConfig, setWooConfig] = useState({
    hostingCost: '299',
    shippingCost: '150',
    gatewayPercentage: 2.9,
    customDevelopment: false
  });

  const [shopifyConfig, setShopifyConfig] = useState({
    selectedPlan: 'standard'
  });

  const handleExport = () => {
    const exportData = {
      currency,
      vatEnabled,
      selectedPlatform,
      wooConfig,
      shopifyConfig,
      exportDate: new Date()?.toISOString()
    };

    const dataStr = JSON.stringify(exportData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `platform-config-${new Date()?.toISOString()?.split('T')?.[0]}.json`;
    link?.click();
    URL.revokeObjectURL(url);
  };

  const handleImport = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json';
    input.onchange = (e) => {
      const file = e?.target?.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          try {
            const importedData = JSON.parse(event?.target?.result);
            setCurrency(importedData?.currency || 'ZAR');
            setVatEnabled(importedData?.vatEnabled ?? true);
            setSelectedPlatform(importedData?.selectedPlatform || 'woocommerce');
            setWooConfig(importedData?.wooConfig || wooConfig);
            setShopifyConfig(importedData?.shopifyConfig || shopifyConfig);
          } catch (error) {
            console.error('Error importing configuration:', error);
          }
        };
        reader?.readAsText(file);
      }
    };
    input?.click();
  };

  return (
    <>
      <Helmet>
        <title>Platform Costs | ROI Calculator</title>
        <meta
          name="description"
          content="Compare e-commerce platform costs"
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <PrimaryNav />
        <MobileMenu />

        <main className="main-content">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Platform Cost Comparison
            </h1>
            <p className="text-sm text-muted-foreground">
              Compare WooCommerce and Shopify costs for your business
            </p>
          </div>

          <ConfigurationToolbar
            currency={currency}
            onCurrencyChange={setCurrency}
            vatEnabled={vatEnabled}
            onVatToggle={() => setVatEnabled(!vatEnabled)}
            onExport={handleExport}
            onImport={handleImport}
          />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <PlatformCard
              platform="woocommerce"
              isSelected={selectedPlatform === 'woocommerce'}
              onSelect={() => setSelectedPlatform('woocommerce')}
              config={wooConfig}
              onConfigChange={setWooConfig}
              currency={currency}
              vatEnabled={vatEnabled}
            />

            <PlatformCard
              platform="shopify"
              isSelected={selectedPlatform === 'shopify'}
              onSelect={() => setSelectedPlatform('shopify')}
              config={shopifyConfig}
              onConfigChange={setShopifyConfig}
              currency={currency}
              vatEnabled={vatEnabled}
            />
          </div>

          <ComparisonSummary
            wooConfig={wooConfig}
            shopifyConfig={shopifyConfig}
            currency={currency}
            vatEnabled={vatEnabled}
          />
        </main>
      </div>
    </>
  );
};

export default PlatformConfigurationCostManagement;